import _ from 'lodash';

export default {
  'equalStrings': (thisString, thatString) => (
      thisString &&
      thatString &&
      thisString === thatString),
  'trueIfNotBlank': (aVal, anotherVal) => {
    if (_.isUndefined(aVal) || _.isEmpty(aVal)) {
      return true;
    }

    return ((anotherVal) && (aVal && aVal.trim().length > 0));
  },
  'dateInFuture': (aDate) => aDate.getTime() >= new Date().getTime(),
  'ensureDocsLength': (bankAccountNumber, docs) => {
    if (!bankAccountNumber) {
      return true;
    }

    return (bankAccountNumber && (docs.length > 0));
  },
  'validateRegex': (idRegex, target) => {
    // eslint-disable-next-line security/detect-non-literal-regexp
    const regex = new RegExp(idRegex);

    return regex.test(target);
  }
};
